import React, { useEffect, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Checkbox, Col, Form, Input, InputNumber, Row, Select, Spin } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { checkInKrQuantiMonth, getKrQuantiCheckInHalfMonth, reset } from 'app/entities/checkIn/checkIn.reducer';
import { checkInKrQuantiHalfMonthAdjust } from 'app/entities/kr/kr-quantitative.reducer';
import ObjectiveUpdate from 'app/entities/objective/form/objective-update';
import { KrTypes } from 'app/shared/model/enum/kr.enum';
import { QuantitativeEvaluationType } from 'app/shared/model/enum/quantitativeEvaluation.enum';
import { StatusType } from 'app/shared/model/enum/status.enum';
import { TrendingTypes } from 'app/shared/model/enum/trending.enum';
import { formatNumber, parseNumber } from 'app/shared/util/help';
import { displayPercent } from 'app/shared/util/percent';
import { filterOption } from 'app/shared/util/select-filter';
import * as _ from 'lodash';
import KRUpdate from '../../kr-update';

type IReportQuantitativeResult = {
  handleClose: (isReload?: boolean) => void;
  krCheckIn?: any;
  handleNextData: () => void;
  hideNextKr: boolean;
};

export const ReportQuantitativeResult = ({ handleClose, krCheckIn, handleNextData, hideNextKr }: IReportQuantitativeResult) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const filters = useAppSelector(state => state.filters.orgCheckIn);
  const workStatusList = useAppSelector(state => state.common.workStatus);
  const entity = useAppSelector(state => state.checkIn.entity);
  const [isOpenModalFormKr, setIsOpenModalFormKr] = useState(false);
  const [isOpenModalFormObjective, setIsOpenModalFormObjective] = useState(false);
  const [isUpdating, setUpdating] = useState(false);
  const modalContentRef = useRef(null);

  // watch values form
  const workStatusMonthValues = Form.useWatch('workStatus', form);
  const metricValueHalfMonthValues = Form.useWatch('metricValueHalfMonth', form);
  const metricValueQuarterValues = Form.useWatch('metricValueQuarter', form);
  const accumulatedResultValues = Form.useWatch('accumulatedResult', form);

  useEffect(() => {
    if (krCheckIn && filters) {
      form.resetFields();
      innitData();
    }
  }, [krCheckIn]);

  useEffect(() => {
    if (entity) {
      if (entity?.keyResultHalfMonth) {
        form.setFieldValue('workStatus', entity?.keyResultHalfMonth?.workStatus)
        form.setFieldValue('metricValueHalfMonth', entity?.keyResultHalfMonth?.result)
        form.setFieldValue('unFinishNote', entity?.keyResultHalfMonth?.unFinishNote)
      }
      if (entity?.adjustment) {
        form.setFieldValue('issue', entity?.adjustment?.adjustmentIssue)
        form.setFieldValue('adjustmentNote', entity?.adjustment?.adjustmentNote)
        form.setFieldValue('solution', entity?.adjustment?.adjustmentSolution)
      }
    }
  }, [entity]);

  useEffect(() => {
    if (krCheckIn?.krType === KrTypes.AccumulateQuantitative) {
      // lũy kế thực hiện quý
      const valueQuarter = metricValueHalfMonthValues != null ? (entity?.keyResultQuarter?.result ?? 0) + metricValueHalfMonthValues : null;
      if (_.isInteger(valueQuarter)) form.setFieldValue('metricValueQuarter', valueQuarter);
      else form.setFieldValue('metricValueQuarter', parseFloat(valueQuarter?.toFixed(2)));

    }
    if (entity?.keyResultHalfMonth?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point) {
      // % thực hiện tháng tính đến nửa tháng
      const resultMonth = displayPercent(
        calculatorPercentByTrending(
          entity?.keyResultHalfMonth?.metricType,
          metricValueHalfMonthValues,
          entity?.keyResultMonth?.metricValue,
        ),
      );
      if (_.isInteger(resultMonth)) form.setFieldValue('estimatePointMonth', resultMonth);
      else form.setFieldValue('estimatePointMonth', parseFloat(resultMonth.toFixed(2)));
    }
  }, [metricValueHalfMonthValues])

  useEffect(() => {
    if (krCheckIn?.krType === KrTypes.AccumulateQuantitative && metricValueQuarterValues !== null) {
      // lũy kế thực hiện năm
      const valueYear = metricValueHalfMonthValues != null ? (entity?.keyResultYear?.result ?? 0) + metricValueHalfMonthValues : null;
      if (_.isInteger(valueYear)) form.setFieldValue('accumulatedResult', valueYear);
      else form.setFieldValue('accumulatedResult', parseFloat(valueYear?.toFixed(2)));

    }
    if (entity?.keyResultHalfMonth?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point) {
      // % thực hiện quý tính đến nửa tháng
      const percentResultQuarter = displayPercent(
        calculatorPercentByTrending(
          entity?.keyResultHalfMonth?.metricType,
          metricValueQuarterValues,
          entity?.keyResultQuarter?.metricValue,
        ),
      );
      if (_.isInteger(percentResultQuarter)) form.setFieldValue('estimatePointQuarter', percentResultQuarter);
      else form.setFieldValue('estimatePointQuarter', parseFloat(percentResultQuarter.toFixed(2)));
    }
  }, [metricValueQuarterValues])

  useEffect(() => {
    if (entity?.keyResultHalfMonth?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point && accumulatedResultValues !== null) {
      // % thực hiện lũy kế năm tính đến nửa tháng
      const percentResultYear = displayPercent(
        calculatorPercentByTrending(
          entity?.keyResultHalfMonth?.metricType,
          accumulatedResultValues,
          entity?.keyResultYear?.metricValue,
        ),
      );
      if (_.isInteger(percentResultYear)) form.setFieldValue('accumulatePoint', percentResultYear);
      else form.setFieldValue('accumulatePoint', parseFloat(percentResultYear.toFixed(2)));
    }
  }, [accumulatedResultValues])

  const innitData = () => {
    dispatch(getKrQuantiCheckInHalfMonth({ krId: krCheckIn?.id, planPeriodId: filters?.planPeriodId }));
  };

  const calculatorPercentByTrending = (calculation, numerator, denominator): number => {
    if (calculation === TrendingTypes.Above) {
      if (denominator > 0) return (numerator ?? 0) / denominator;
      return 0;
    } else {
      if (numerator > 0) return denominator / numerator;
      return 0;
    }
  };

  const MapperPayload = (values: any) => {
    const valueMonth = {
      reportScheduleId: entity?.reportScheduleId,
      reportObjectId: krCheckIn?.id,
      planPeriodId: entity?.planPeriodId,
      workStatus: values.workStatus,
      unFinishNote: values.unFinishNote,
      metricValue: metricValueHalfMonthValues !== null ? metricValueHalfMonthValues : null,
    };
    const valueAdjustment = {
      solution: values.solution,
      adjustmentNote: values.adjustmentNote,
      issue: values.issue,
      krId: krCheckIn?.id,
      sendingNotification: values.sendingNotification,
    };
    return { valueMonth, valueAdjustment };
  };

  const handleSubmit = values => {
    const { valueMonth, valueAdjustment } = MapperPayload(values);
    setUpdating(true);
    Promise.all([
      dispatch(checkInKrQuantiMonth(valueMonth)),
      dispatch(checkInKrQuantiHalfMonthAdjust(valueAdjustment)),
    ])
      .then(response => {
        const isFailed = _.some(response, o => {
          return !o.payload;
        });
        if (isFailed) return;
        form.resetFields();
        handleClose(true);
      })
      .catch(() => {
        return;
      })
      .finally(() => {
        setUpdating(false);
      });
  };

  const handleNextKr = () => {
    form
      .validateFields()
      .then(values => {
        const { valueMonth, valueAdjustment } = MapperPayload(values);
        setUpdating(true);
        Promise.all([
          dispatch(checkInKrQuantiMonth(valueMonth)),
          dispatch(checkInKrQuantiHalfMonthAdjust(valueAdjustment)),
        ])
          .then(response => {
            const isFailed = _.some(response, o => {
              return !o.payload;
            });
            if (isFailed) return;
            dispatch(reset());
            form.resetFields();
            form.scrollToField('reportScheduleName');
            handleNextData();
          })
          .catch(() => {
            return;
          })
          .finally(() => {
            setUpdating(false);
          });
      })
      .catch((err) => {
        return err;
      })
  };

  const handleEditKr = () => {
    setIsOpenModalFormKr(true);
  };

  const handleCloseModelKr = () => {
    setIsOpenModalFormKr(false);
  };

  const handleEditObjective = () => {
    setIsOpenModalFormObjective(true);
  };

  const handleCloseModelObjective = () => {
    setIsOpenModalFormObjective(false);
  };

  return (
    <Spin delay={500} spinning={isUpdating}>
      <Form ref={modalContentRef} size="large" form={form} className='fw-bold' onFinish={handleSubmit} layout="vertical">
        <Title className="fw-bold" level={2}>
          {`Báo cáo thực hiện KR ${filters?.accountableName ? filters.accountableName : ''}`}
        </Title>
        <Row>
          <Col md={5}>
            <Form.Item label="Kỳ kế hoạch">
              <Input className="w-100" disabled value={entity?.planPeriodName} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={5}>
            <Form.Item label="Kỳ báo cáo">
              <Input size='large' value={entity?.reportScheduleName} readOnly />
            </Form.Item>
          </Col>
          {/* <Col md={1} />
          <Col>
            <div className="mt-4">
              <span className="cursor-pointer text-primary" onClick={() => handleEditKr()}>
                {`Xem chi tiết KR >`}
              </span>
              <br />
              <span className="cursor-pointer text-primary" onClick={() => handleEditObjective()}>
                {`Xem chi tiết mục tiêu >`}
              </span>
            </div>
          </Col> */}
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label={`Mục tiêu - ${entity?.objective?.code}`}>
              <TextArea rows={1} className="w-100" disabled value={entity?.objective?.purpose} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={3}>
            <Form.Item label="Lĩnh vực">
              <Input className="w-100" disabled value={entity?.objective?.fieldName} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={3}>
            <Form.Item label="Dự án">
              <Input className="w-100" disabled value={entity?.objective?.projectName} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item label="Mảng công việc">
              <Input className="w-100" disabled value={entity?.objective?.workTypeName} size="large" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <Form.Item label="Mã">
              <Input className="w-100" disabled value={entity?.keyResultYear?.code} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={7}>
            <Form.Item label="Tên chỉ tiêu">
              <Input className="w-100" disabled value={entity?.keyResultYear?.metricName} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={5}>
            <Form.Item label="Đơn vị tính">
              <Input className="w-100" disabled value={entity?.keyResultYear?.metricUnit} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={6}>
            <Form.Item label="Chỉ tiêu năm">
              <InputNumber
                className="w-100"
                formatter={formatNumber}
                parser={parseNumber}
                disabled
                value={_.isInteger(entity?.keyResultYear?.metricValue) ? entity?.keyResultYear?.metricValue : entity?.keyResultYear?.metricValue?.toFixed(2)}
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col className="fw-bold h3" md={24}>
            Thực hiện {entity?.keyResultHalfMonth?.name}
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <Form.Item label={`Chỉ tiêu ${entity?.keyResultQuarter?.name}`}>
              <InputNumber
                className="w-100"
                formatter={formatNumber}
                parser={parseNumber}
                disabled
                value={_.isInteger(entity?.keyResultQuarter?.metricValue) ? entity?.keyResultQuarter?.metricValue : entity?.keyResultQuarter?.metricValue?.toFixed(2)}
                size="large"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item label={`Chỉ tiêu ${entity?.keyResultMonth?.name}`}>
              <InputNumber
                formatter={formatNumber}
                parser={parseNumber}
                className="w-100"
                disabled
                value={_.isInteger(entity?.keyResultMonth?.metricValue) ? entity?.keyResultMonth?.metricValue : entity?.keyResultMonth?.metricValue?.toFixed(2)}
                size="large"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item label={`Thực hiện ${entity?.keyResultHalfMonth?.name}`}
              rules={[{ required: true, message: `Hãy nhập thực ${entity?.keyResultHalfMonth?.name}` }]}
              name={'metricValueHalfMonth'}
            >
              <InputNumber step={0.01} precision={2} formatter={formatNumber} parser={parseNumber} className="w-100" size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            {krCheckIn?.krType === KrTypes.AccumulateQuantitative && (
              <Form.Item label={`Thực hiện ${entity?.keyResultQuarter?.name}`} name={'metricValueQuarter'}>
                <InputNumber
                  disabled
                  formatter={formatNumber}
                  parser={parseNumber}
                  className="w-100" size="large" />
              </Form.Item>
            )}
          </Col>
          <Col md={1} />
          <Col md={4}>
            {krCheckIn?.krType === KrTypes.AccumulateQuantitative && (
              <Form.Item label="Thực hiện lũy kế từ đầu năm" name={'accumulatedResult'}>
                <InputNumber
                  disabled
                  formatter={formatNumber}
                  parser={parseNumber}
                  className="w-100"
                  size="large"
                />
              </Form.Item>
            )}
          </Col>
        </Row>
        {entity?.keyResultHalfMonth?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point && (
          <Row>
            <Col md={9}>
              <Form.Item label="Tỷ lệ hoàn thành (%)">
                <TextArea
                  rows={1}
                  disabled
                  className="w-100"
                  value={entity?.keyResultHalfMonth?.evaluationMethodQuantitativeNote}
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={4}>
              <Form.Item label={`KR ${entity?.keyResultMonth?.name}`} name={'estimatePointMonth'}>
                <InputNumber
                  disabled
                  formatter={formatNumber}
                  parser={parseNumber}
                  className="w-100"
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={4}>
              <Form.Item
                label={`KR ${entity?.keyResultQuarter?.name}`} name={'estimatePointQuarter'}>
                <InputNumber
                  disabled
                  formatter={formatNumber}
                  parser={parseNumber}
                  className="w-100"
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={4}>
              <Form.Item label="Lũy kế so với KR năm" name={'accumulatePoint'}>
                <InputNumber
                  disabled
                  formatter={formatNumber}
                  parser={parseNumber}
                  className="w-100"
                  size="large"
                />
              </Form.Item>
            </Col>
          </Row>
        )}

        <Row>
          <Col md={7}>
            <Form.Item label="Tình trạng KR tháng"
              rules={[{ required: true, message: 'Hãy chọn tình trạng' }]}
              name="workStatus">
              <Select
                filterOption={filterOption}
                allowClear
                showSearch
                size="large"
                options={workStatusList}
                placeholder="Chọn tình trạng"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={16}>
            <Form.Item
              label="Lý do Tạm dừng/Hủy"
              rules={[
                {
                  required: workStatusMonthValues && (workStatusMonthValues === StatusType.Postponed || workStatusMonthValues === StatusType.Cancel),
                  message: `Hãy nhập lý do`,
                },
              ]}
              name={'unFinishNote'}
            >
              <TextArea rows={1} placeholder="Nhập lý do" size="large" />
            </Form.Item>

          </Col>
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label="Khó khăn & nguyên nhân" name={'issue'}>
              <TextArea rows={6} placeholder="Nhập khó khăn & nguyên nhân" size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={12}>
            <Form.Item label="Giải pháp và kiến nghị" name={'solution'}>
              <TextArea rows={6} placeholder="Nhập giải pháp và kiến nghị" size="large" />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col md={24}>
            <Form.Item label="Link tài liệu đính kèm" name={'adjustmentNote'}>
              <TextArea placeholder="Nhập tài liệu đính kèm về kết quả thực hiện" size="large" />
            </Form.Item>
            <Form.Item valuePropName="checked" name={'sendingNotification'}>
              <Checkbox>Gửi thông báo đến người nhận</Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Row className="d-flex gap-3 mt-3" justify="end">
            {!hideNextKr &&
              <Col>
                <Button
                  className="green"
                  onClick={() => {
                    handleNextKr();
                  }}
                  disabled={isUpdating}
                >
                  Lưu & Chuyển sang check in KR khác
                </Button>
              </Col>
            }
            <Col>
              <Button
                className="secondary"
                onClick={() => {
                  handleClose();
                }}
              >
                Hủy
              </Button>
            </Col>
            <Col>
              <Button className="primary" htmlType="submit" disabled={isUpdating}>
                Lưu
              </Button>
            </Col>
          </Row>
        </Form.Item>
        {isOpenModalFormObjective && (
          <ObjectiveUpdate isOpen={isOpenModalFormObjective} id={entity?.objective?.id} onClose={handleCloseModelObjective} />
        )}
        {isOpenModalFormKr && (
          <KRUpdate
            isOpen={isOpenModalFormKr}
            idKrBaseSelected={krCheckIn?.id}
            idObjective={entity?.objective?.id}
            planPeriodType={filters?.planPeriodType}
            krTypeRequest={krCheckIn?.krType}
            planPeriodIdSelected={filters?.planPeriodId}
            onClose={handleCloseModelKr}
          />
        )}
      </Form>
    </Spin>
  );
};

export default ReportQuantitativeResult;
